import { COUNTRY_CODES, type DeveloperApplicationInput } from '@mogzo/shared';
import { apiFetch } from './api';

export interface ApplicationThread {
  name: string;
  expiresAt: string;
  messages: { author: 'staff' | 'applicant'; body: string; createdAt: string }[];
}

export function sendApplication(
  input: DeveloperApplicationInput,
  turnstileToken: string | null,
): Promise<{ ok: true }> {
  return apiFetch('/v1/developer-applications', {
    method: 'POST',
    body: JSON.stringify({ ...input, ...(turnstileToken ? { turnstileToken } : {}) }),
  });
}

export function confirmApplication(token: string): Promise<{ name: string }> {
  return apiFetch('/v1/developer-applications/confirm', {
    method: 'POST',
    body: JSON.stringify({ token }),
  });
}

export function fetchQuestion(token: string): Promise<ApplicationThread> {
  return apiFetch('/v1/developer-applications/question', {
    method: 'POST',
    body: JSON.stringify({ token }),
  });
}

export function sendAnswer(token: string, body: string): Promise<{ ok: true }> {
  return apiFetch('/v1/developer-applications/answer', {
    method: 'POST',
    body: JSON.stringify({ token, body }),
  });
}

const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

/** Countries for the apply form, sorted by English name. */
export const COUNTRIES = COUNTRY_CODES.map((code) => ({
  code,
  name: regionNames.of(code) ?? code,
})).sort((a, b) => a.name.localeCompare(b.name));
